import React, { useState } from "react";
import { db, } from "../../services/firebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import AlertMessage from "../../components/AlertMessage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

import "../../styles/UserForm.css";

const districtsInSelangor = [
    "Ampang", "Bangi", "Damansara", "Gombak", "Hulu Langat", "Hulu Selangor",
    "Kapar", "Klang", "Kota Raja", "Kuala Langat", "Kuala Selangor", "Pandan",
    "Petaling Jaya", "Puchong", "Sabak Bernam", "Selayang", "Sepang",
    "Shah Alam", "Sg. Buloh", "Sungai Besar", "Subang", "Tanjung Karang"
];


const UserForm = ({ currentRole, currentUserId, currentDistrict, onMenuSelect }) => {
    const [name, setName] = useState("");
    const [phone, setPhone] = useState("");
    const [role, setRole] = useState(currentRole === "pengarah" ? "pengerusi" : "pengurus");
    const [district, setDistrict] = useState(currentRole === "pengerusi" ? currentDistrict : "");
    const [branchName, setBranchName] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showAlert, setShowAlert] = useState(false);


    const togglePasswordVisibility = () => {
        setShowPassword((prev) => !prev);
    };

    const addUser = async (e) => {
        e.preventDefault();
        try {
            const userData = {
                name,
                phone,
                role,
                district, // Simpan district sebagai field
                password,
                createdBy: currentUserId
            };

            if (currentRole === "pengerusi") {
                userData.branchName = branchName;
            }

            const userCollectionRef = collection(db, "inventori", "selangor", "users");
            console.log("Menambah pengguna ke Firestore:", userData);

            await addDoc(userCollectionRef, userData);
            console.log("Pengguna berjaya ditambah!");

            setShowAlert(true);

            setTimeout(() => {
                setShowAlert(false);
                onMenuSelect("Senarai Pengguna");
            }, 2000);

            // Kosongkan input
            setName("");
            setPhone("");
            setRole(currentRole === "pengarah" ? "pengerusi" : "pengurus");
            setDistrict(currentRole === "pengerusi" ? currentDistrict : "");
            setBranchName("");
            setPassword("");


        } catch (error) {
            console.error("Error adding user:", error);
            alert("Gagal menambah pengguna. Sila cuba lagi.");
        }
    };



    return (
        <div className="user-form-container">
            <AlertMessage message="Berjaya ditambah!" isVisible={showAlert} />

            <h2>Tambah Pengguna</h2>
            <form onSubmit={addUser} className="user-form">
                <label>Nama:</label>
                <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />

                <label>No Telefon:</label>
                <input type="tel" value={phone} onChange={(e) => setPhone(e.target.value)} required />
                <label>Peranan:</label>
                <input type="text" value={role} disabled required />
                {currentRole === "pengarah" ? (
                    <>
                        <label>Kawasan:</label>
                        <select value={district} onChange={(e) => setDistrict(e.target.value)} required>
                            <option value="">Pilih Kawasan</option>
                            {districtsInSelangor.map((district) => (
                                <option key={district} value={district}>{district}</option>
                            ))}
                        </select>
                    </>
                ) : (
                    <>
                        <label>Kawasan:</label>
                        <input type="text" value={district} disabled required />
                    </>
                )}
                {currentRole === "pengerusi" && (
                    <>
                        <label>Nama Cawangan:</label>
                        <input type="text" value={branchName} onChange={(e) => setBranchName(e.target.value)} required />
                    </>
                )}
                <label>Kata Laluan:</label>
                <div className="password-field">
                    <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} required />
                    <button
                        type="button"
                        className="toggle-password"
                        onClick={togglePasswordVisibility}
                    >
                        <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                    </button>
                </div>
                <button type="submit" className="submit-button">Tambah</button>
            </form>
        </div>
    );
};

export default UserForm;